export default function reTry<T, R>(fn: (arg: T) => R, countReTry = 5): (arg: T) => Promise<R> {
  const arr = new Array(countReTry).fill('');
  return async (arg: T): Promise<R> => {
    for (let i = arr.length - 1; i >= 0; i--) {
      try {
        // eslint-disable-next-line no-await-in-loop
        return await fn(arg);
      } catch (error) {
        if (i === 0) {
          throw error;
        }
      }
    }

    throw new Error('Что-то пошло не так при повторном запросе');
  };
}
